<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
    }
  },
  created() {

  },
  mounted() {

    let params = this.$route.query.hasOwnProperty('Referral') ? `Referral=${this.$route.query.Referral}` : ''
    if (this._isMobile()) {
      this.$router.replace(`/tron_m?${params}`);



    } else {
      this.$router.replace(`/tron_pc?${params}`);
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }

  },

};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>




// WEBPACK FOOTER //
// src/App.vue